import "./style.scss";
import {Link} from "react-router-dom";
import { useHistory } from 'react-router-dom'
import useWindowDimensions from "helpers/screen";
import { useState, useEffect, useRef } from "react";


const VerticalNavigationTab = ({members = [], horizontal=false}) => {
  const [selected, setSelected] = useState(0)
  const {width} = useWindowDimensions();

  const history = useHistory()
  return <div className={"verticalNavigation " + (horizontal && "horizontal")}>
      {members.map((item, i) => {
          if(history.location.pathname === item.url && i != selected){
            setSelected(i)
          }
          return (
            <Link onClick={() => window.scrollTo(0,0)} to={item.url} key={i} className={history.location.pathname === item.url ? "menuItem _selected" : "menuItem"}>
              {item.icon}
              <p>{item.title}</p>
            </Link>)
        }
      )}
  </div>

}

export default VerticalNavigationTab;